'use client';
import type { ReactElement } from 'react';
import { Pagination, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import Image from 'next/image';
import _man_ from '@/assets/image/man.png';
import _women_ from '@/assets/image/women.jpeg';
import _child_ from '@/assets/image/child.jpeg';
import _home_ from '@/assets/image/home.png';
// import _optics_ from '@/assets/image/optics.jpeg';
// import _beauty_ from '@/assets/image/beauty.jpeg';
import Link from 'next/link';
import { memo } from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';

const Slider = (): ReactElement => {
  return (
    <div className="slider-container pb-4 pt-4">
      <Swiper
        modules={[Pagination, Navigation]}
        navigation={{
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }}
        pagination={{
          clickable: true,
          el: '.custom-pagination',
        }}
        spaceBetween={10}
        className="h-full"
      >
        {/* <SwiperSlide>
          <Link href={'catalog/beauty'}>
            <Image
              src={_beauty_}
              alt={''}
              width={317}
              height={205}
              className="h-[205px] w-full rounded-2xl object-cover object-[45%_62%]"
              quality={100}
              priority
            />
            <h3 className="absolute bottom-5 right-11">Бьюти</h3>
          </Link>
        </SwiperSlide>
        <SwiperSlide>
          <Link href={'catalog/optics'}>
            <Image
              src={_optics_}
              alt={''}
              width={317}
              height={205}
              className="h-[205px] w-full rounded-2xl object-cover object-[left_top]"
              quality={100}
              priority
            />
            <h3 className="absolute bottom-5 right-11">Очки</h3>
          </Link>
        </SwiperSlide> */}
        <SwiperSlide>
          <Link href={'catalog/woman'}>
            <Image
              src={_women_}
              alt={''}
              width={317}
              height={205}
              className="h-[205px] w-full rounded-2xl object-cover object-[left_top]"
              quality={100}
              priority
            />
            <h3 className="absolute bottom-5 right-11">Женское</h3>
          </Link>
        </SwiperSlide>
        <SwiperSlide>
          <Link href={'catalog/man'}>
            <Image
              src={_man_}
              alt={''}
              width={328}
              height={205}
              className="h-[205px] w-full rounded-2xl object-cover object-[left_top]"
              quality={100}
              priority
            />
            <h3 className="absolute bottom-5 right-11">Мужское</h3>
          </Link>
        </SwiperSlide>
        <SwiperSlide>
          <Link href={'catalog/children'}>
            <Image
              src={_child_}
              alt={''}
              width={317}
              height={205}
              className="h-[205px] w-full rounded-2xl object-cover object-[left_top]"
              quality={100}
              priority
            />
            <h3 className="absolute bottom-5 right-11 text-[#4f3e35]">
              Детское
            </h3>
          </Link>
        </SwiperSlide>
        <SwiperSlide>
          <Link href={'catalog/home'}>
            <Image
              src={_home_}
              alt={''}
              width={317}
              height={205}
              className="h-[205px] w-full rounded-2xl object-cover object-[left_top]"
              quality={100}
              priority
            />
            <h3 className="absolute bottom-5 right-11">Товары для дома</h3>
          </Link>
        </SwiperSlide>
        <ArrowLeft className="swiper-button-prev" color="white" />
        <ArrowRight className="swiper-button-next" color="white" />
      </Swiper>
      <div className="custom-pagination mt-5 text-center"></div>
    </div>
  );
};
export default memo(Slider);
